import { ArrowsPointingOutIcon } from '@heroicons/react/20/solid'
import classNames from 'classnames'

import useConfig from '@/gf/hooks/useConfig'

import Id from '@/gf/modules/Id'

import A from '@/gf/components/A'
import { Fragment, ReactNode } from 'react'

const BrokerWarning = ({ className, children }: { className?: string; children: ReactNode }) => (
  <div
    className={classNames(
      'px-4 py-3 flex flex-row gap-x-2 items-center rounded-md bg-purple-50 border border-purple-300 text-purple-800 font-medium',
      className
    )}
  >
    <ArrowsPointingOutIcon className="w-5 h-5 inline-flex shrink-0 text-purple-600" />
    {children}
  </div>
)

const Request = ({ brokerRfqIds, className }: { brokerRfqIds: string[]; className?: string }) => {
  const config = useConfig()
  return (
    <BrokerWarning className={className}>
      <span>
        Brokered by{' '}
        {brokerRfqIds.map((rfqId, index) => (
          <Fragment key={rfqId}>
            {index !== 0 && ' AND '}
            <A.T key={rfqId} href={`${config.buyersUrl}/rfqs/${rfqId}`} target="_blank">
              Request {Id.shorten(rfqId)}
            </A.T>
          </Fragment>
        ))}
      </span>
    </BrokerWarning>
  )
}
BrokerWarning.Request = Request

export default BrokerWarning
